import _ from 'lodash'
import { SwxTheme } from 'swx-atomic-component-lib'

const formPasswordRowStyle = `
  display: flex;
  flex: 0 0 auto;
  align-items: stretch;
  margin-bottom: 24px;
  width: 50%;
`

const formPasswordAgainRowStyle = `
  display: flex;
  flex: 0 0 auto;
  align-items: stretch;
  margin-bottom: 24px;
  width: 50%;
`
const formPasswordColumn = `
  display: flex;
  flex: 0 0 auto;
  align-items: stretch;
  margin-bottom: 24px;
  width: 100%;
`

const containerPasswordStyle = (score, passwordValue, minScore) => {
  return ({
    customStyle: `    
    button {
      opacity: 1;
    }

    input {
      color: ${SwxTheme.palette.black} !important;
      letter-spacing: 0px;
      font-size: 14px;
      background-color: ${SwxTheme.palette.white};

      & + label {
        opacity: 0.7;
      }
      
      box-shadow: none !important;
      
      ${score < minScore && !_.isEmpty(_.trim(passwordValue)) ? `border-color: ${SwxTheme.palette.highlight};` : ''}
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      input {
        padding-right: 38px;

        & + label {
          display: none;
        }
      }
    }
  `
  })
}

const strengthMeterStyle = `  
  > div > div {
    &[data-strength="0"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="1"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="2"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="3"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
    
    &[data-strength="4"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
    
    &[data-strength="5"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
  }
`

const fullWidth = `
  width: 100% !important;
`

const halfWidth = `
  width: 50% !important;
  padding-right: 25px;
  @media only screen and (max-width: 600px) {
    width: 100% !important;
    padding: 0 20px !important;
  }
`

const meterHolderStyle = `
  width: 100% !important;
  padding-right: 0px !important;
  margin-top: 0px !important;
  padding-left: 45px;  
`

const doubleIconLeftStyle = {
  position: 'absolute'
}

const doubleIconRightStyle = {
  position: 'absolute',
  left: '9px'
}

const inputStyle = `
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${SwxTheme.palette['secondary-mid']};
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${SwxTheme.palette['secondary-mid']} !important;
  }
  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${SwxTheme.palette['secondary-mid']};
  }
`

export {
  formPasswordRowStyle,
  formPasswordAgainRowStyle,
  containerPasswordStyle,
  strengthMeterStyle,
  meterHolderStyle,
  doubleIconLeftStyle,
  doubleIconRightStyle,
  inputStyle,
  formPasswordColumn,
  fullWidth,
  halfWidth
}
